import React,{useState} from 'react';
import './Navbar.scss';
import brandImg from '../../../assets/image/sudexlogo.png';
import profileImg from '../../../assets/image/homepageback.png';
import { Link } from 'react-router-dom';
import Chat from '../../chatsection/Chat';
const Navbar = () => {
    const barstoggler =()=>{
            const bars = document.querySelector('.bars')
            const navdrop = document.querySelector('.navbar-drop');
            navdrop.classList.toggle('show-menu');
            bars.classList.toggle('bars-toggle')      
    }
   
    return (
        <div className='navbar'>
            <Chat/>
            <div className="navbar-drop ">
                <div className="container-sm">
                    <div className="search-box">
                        <form method='POST' className="search-form">
                            <form className="form-group" method="POST">
                                <input type="text" id="search" placeholder="Qidirish..." /> <button type="submit"><i className="fa fa-search"></i></button>
                            </form>
                            <select className="language-select right-item">
                                <option className="language-item">Uzb</option>
                                <option className="language-item">Uzb</option>
                                <option className="language-item">Uzb</option>
                            </select >

                            <Link to="/chat" className="message-bell right-item">
                                <i className="fa fa-bell"></i>
                                <span className="counter">0</span>
                            </Link>
                        </form>
                    </div>
                    <div className="right-navbar">

                        <div className="profile-link right-item">
                            <Link onClick={barstoggler} to="/myprofile" className='profile-img' id='profile-img'>
                                <i className="material-icons">person_pin</i>
                                <label for="profile-img">Shaxsiy kabinet</label>
                            </Link>

                        </div>
                    </div>
                    <div className="navbar-links">
                        <Link onClick={barstoggler} to="/landingpage">
                            Bosh Sahifa
                        </Link>
                        <Link onClick={barstoggler} to="/categories">
                            Kategoriyalar
                        </Link>
                        <Link onClick={barstoggler} to="/history">
                            Arxiv
                        </Link>
                    </div>
                </div>
                <div className="bottom-line"></div>
            </div>
            <div className="navbar-content container">
                <Link to="/landingpage" className="navbar-logo">
                    <img src={brandImg} /><span className="brand-name">Sudex</span>
                </Link>
                <div className="bars" onClick={barstoggler}>
                    <div className='bar'></div>
                    <div className='bar'></div>
                    <div className='bar'></div>
                </div>
                <div className="navbar-links">
                    <Link  to="/landingpage">
                        Bosh Sahifa
                    </Link>
                    <Link  to="/categories">
                        Kategoriyalar
                    </Link>
                    <Link  to="/history">
                        Arxiv
                    </Link>
                </div>
                <div className="search-box">
                    <form className="search-form">
                        <div className="form-group">
                            <input type="text" id="search" placeholder="Qidirish..." /> <label for="search"><i className="fa fa-search"></i></label>
                        </div>
                    </form>
                </div>
                <div className="right-navbar">
                    <select className="language-select right-item">
                        <option className="language-item">Uzb</option>
                        <option className="language-item">Uzb</option>
                        <option className="language-item">Uzb</option>
                    </select >
                    <Link to="/chat" className="message-bell right-item">
                        <i className="fa fa-bell"></i>
                        <span className="counter">0</span>
                    </Link>
                    <div className="profile-link right-item">
                        <Link to="/myprofile" className='profile-img' id='profile-img'>
                            <img src={profileImg} width="50px" />
                            <label for="profile-img">Profile Named</label>
                        </Link>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
